import type { TransformerExtended } from "../Models/Domain/Transformer";

const DefaultTransformerGenerator = <
  DomainModel = unknown,
  ApiModel = unknown,
  UIModel = unknown,
>(): TransformerExtended<DomainModel, ApiModel, UIModel> => ({
  toApi(input: DomainModel): ApiModel {
    throw new Error(`Transformation not available for input ${input}`);
  },

  toDomain(input: ApiModel): DomainModel {
    throw new Error(`Transformation not available for input ${input}`);
  },

  toUi(input: DomainModel): UIModel {
    throw new Error(`Transformation not available for input ${input}`);
  },

  fromUiToDomain(input: UIModel): DomainModel {
    throw new Error(`Transformation not available for input ${input}`);
  },
});

export default DefaultTransformerGenerator;
